// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OX6D","title":"styles_title__1jFtz"};